import React, { FC } from 'react';
import { Skeleton, Space } from 'antd';
import { useAccountsByIdsQuery, useAccountsQuery } from '~/hooks/accounts';
import UnknownAccount from '~/pages/accounts/components/UnknownAccount';

interface AccountByIdProps {
  accountId: string;
}

const AccountById: FC<AccountByIdProps> = (props) => {
  const { accountId } = props;
  const { data: accounts, isLoading } = useAccountsQuery();
  const account = accounts?.find((account) => account?.id === accountId);
  if (isLoading)
    return <Skeleton.Button active size="small" style={{ height: 16, minWidth: 150 }} />;
  return <div>{account?.number}</div>;
};

interface AccountsByIdsProps {
  accountIds: string[];
  withCurrency?: boolean;
}

export const AccountsByIds: FC<AccountsByIdsProps> = (props) => {
  const { accountIds, withCurrency } = props;
  const { data, isLoading } = useAccountsByIdsQuery(accountIds);
  const accounts = data?.data;
  if (isLoading)
    return <Skeleton.Button active size="small" style={{ height: 16, minWidth: 150 }} />;
  if (!accounts || accounts.length === 0) return null;
  return (
    <Space direction="vertical">
      {accountIds?.map((id) => {
        const account = accounts.find((acc) => acc.id === id);
        if (!account) return <UnknownAccount key={id} style={{ marginBottom: 6 }} />;
        return (
          <div key={id}>
            {account.number} {withCurrency && account.currency && `(${account.currency})`}
          </div>
        );
      })}
    </Space>
  );
};

export default AccountById;
